import React from 'react';
import { LoopIcon } from './cartoon/Art';

const passos = [
    {
        kind: 'beba',
        fase: 'FASE 1-1',
        titulo: 'Beba',
        texto: 'Prove sem pressa. Café especial já é docinho e aromático, então experimente antes de colocar açúcar.',
    },
    {
        kind: 'inspire',
        fase: 'FASE 1-2',
        titulo: 'Inspire',
        texto: 'Sinta o cheiro antes do primeiro gole. É ali que aparecem o chocolate, o caramelo e as frutas.',
    },
    {
        kind: 'repita',
        fase: 'FASE 1-3',
        titulo: 'Repita',
        texto: 'Volte amanhã. A cada xícara você percebe um sabor novo, e o café de todo dia vira um momento seu.',
    },
];

export default function Pillars() {
    return (
        <section className="lc lc-section bg-vermelho" id="loop">
            <div className="lc-wrap">
                <div className="lc-center">
                    <span className="lc-pill">o nosso loop</span>
                    <h2 className="lc-title">Beba. Inspire. Repita<span className="lc-dot">.</span></h2>
                    <p className="lc-text">
                        Café especial não precisa ser complicado. É um ritual simples, que fica melhor a cada xícara.
                    </p>
                </div>
                <div className="lc-grid-3" style={{ marginTop: 56 }}>
                    {passos.map((p) => (
                        <article key={p.kind} className="lc-card">
                            <span className="lc-stage">{p.fase}</span>
                            <div style={{ margin: '12px 0 8px' }}><LoopIcon kind={p.kind} /></div>
                            <h3 style={{ fontSize: 30, fontWeight: 700, margin: '0 0 10px' }}>
                                {p.titulo}<span style={{ color: 'var(--lc-verm)' }}>.</span>
                            </h3>
                            <p style={{ fontSize: 17, lineHeight: 1.5 }}>{p.texto}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
